import api from "./api";


export const createTokenSettings = async (data) =>{
    try{
        const response = await api.post('/token-settings/',data)
        return response.data
    }
    catch(error){
        throw new Error(error?.response?.detail?.data)
    }
}


export const getTokenSettingsByOutlet = async (outlet_id) =>{
    try{
        const response = await api.get(`/token-settings/outlet/${outlet_id}`)
        return response.data
    }
    catch(error){
        throw new Error(error?.response?.detail?.data)
    }
}


export const updateTokenSettings = async (outlet_id,data) =>{
    try{
        const response = await api.put(`/token-settings/${outlet_id}`,data)
        return response.data
    }
    catch(error){
        throw new Error(error?.response?.detail?.data)
    }
}


export const resetTokenSettings = async (data) => {
    try{
        const response = await api.post('/token-settings/token/reset_token_settings',data)
        return response.data
    }
    catch(error){
        throw new Error(error?.response?.detail?.data)
    }
}

